// extracted by mini-css-extract-plugin
module.exports = {"resellers-form":"Forms-module__resellers-form___Zyt2u","postfix":"Forms-module__postfix___1i2Z5","button":"Forms-module__button___2AfOT","error":"Forms-module__error___3Q23F"};